import React from "react";
import "./about.css";
import Me from "../../assets/krishan2.png";
import { FaAward } from "react-icons/fa";
import { AiFillProject } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";
const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="krishan"></img>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1000+ hrs Coding </small>
            </article>
            <article className="about__card">
              <AiFillProject className="about__icon" />
              <h5>Projects</h5>
              <small>10+ Completed</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Clients </h5>
              <small>2 Clients</small>
            </article>
          </div>
          <p>
            Software Developer with 1.5 years of experience in the MERN stack
            and Angular. Skilled in API design, JWT authentication, and
            performance optimization. Successfully migrated a legacy Angular app
            to Angular 17, adding features like data visualizations and
            real-time notifications. Experienced in React.js, Node.js, Express,
            PostgreSQL, and Zod, with a focus on building scalable,
            high-performance solutions.
          </p>
          <a href="#contact" className=" btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
